import App from '../../components/App';
import props from '../../configs/propsFancy';

export default function FontGenerator() {
  return <App {...props} />;
}
